module.exports = __webpack_public_path__ + "static/media/ghost-logo.7683968b.svg";